import { forwardRef, type ChangeEvent, type ClipboardEvent } from 'react';
import { TextField, type TextFieldProps } from './TextField.js';

export interface OtpFieldProps extends Omit<TextFieldProps, 'mono' | 'maxLength' | 'onChange' | 'value' | 'inputMode' | 'label'> {
  label?: string;
  value: string;
  onChange: (codice: string) => void;
}

/**
 * Codice a 6 cifre ricevuto via email. Accetta solo cifre, incolla il codice intero,
 * suggerisce il riempimento automatico dai messaggi.
 */
export const OtpField = forwardRef<HTMLInputElement, OtpFieldProps>(function OtpField(
  { value, onChange, label = 'Codice ricevuto via email', ...rest },
  ref,
) {
  function soloCifre(testo: string) {
    return testo.replace(/\D/g, '').slice(0, 6);
  }
  function gestisciChange(e: ChangeEvent<HTMLInputElement>) {
    onChange(soloCifre(e.target.value));
  }
  function gestisciPaste(e: ClipboardEvent<HTMLInputElement>) {
    e.preventDefault();
    onChange(soloCifre(e.clipboardData.getData('text')));
  }
  return (
    <TextField
      ref={ref}
      label={label}
      mono
      value={value}
      onChange={gestisciChange}
      onPaste={gestisciPaste}
      maxLength={6}
      inputMode="numeric"
      pattern="[0-9]*"
      autoComplete="one-time-code"
      placeholder="000000"
      {...rest}
    />
  );
});
